import React from "react";
import "./header.css";
import ME from "../../assets/avatar.JPEG";
import HeaderSocial from "./HeaderSocial";

function Header() {
  return (
    <header>
      <div className="container header__container">
        <h5>Hello I'm</h5>
        <h1>Emre Durmus</h1>
        <h5 className="text-light">Software Developer</h5>
        <HeaderSocial />

        <div className="me">
          <img src={ME} alt="Emre Durmus" />
        </div>

        <a href="#portfolio" className="scroll__down">
          Scroll Down
        </a>
      </div>
    </header>
  );
}

export default Header;
